import { Select } from "antd";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../../assets/translate";

const SelectLanguage = ({ width = 130, style, mini }) => {
  const { t } = useTranslation();
  const [language, setlanguage] = useState(mini ? "VN" : "Tiếng Việt");
  const optionsLanguage = [
    { value: "vn", label: t("Tiếng Việt") },
    { value: "en", label: t("English") },
  ];
  const optionsLanguageMini = [
    { value: "vn", label: t("VN") },
    { value: "en", label: t("EN") },
  ];
  const handleChange = (value) => {
    setlanguage(value === "en" ? "English" : "Tiếng Việt");
  };
  const handleChangeMini = (value) => {
    setlanguage(value === "en" ? "En" : "VN");
  };
  useEffect(() => {
    localStorage.setItem("language", language);
    i18n.changeLanguage(
      language === "Tiếng Việt" || language === "VN" ? "vn" : "en"
    );
  }, [language]);
  return mini ? (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Select
        value={t(language)}
        style={{ ...style, width }}
        onChange={handleChangeMini}
        options={optionsLanguageMini}
      />
    </div>
  ) : (
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ marginRight: 18 }}>{t("Ngôn ngữ")}</span>
      <Select
        value={t(language)}
        style={{ ...style, width }}
        onChange={handleChange}
        options={optionsLanguage}
      />
    </div>
  );
};

export default SelectLanguage;
